import dadosImg from '../../assets/img/semDados.png'
import dadosGraficoProps from '../../interfaces/propsNenhumDadoGrafico'
import './nenhumdadografico.css'

function NenhumDadoGrafico (props: dadosGraficoProps ) {

    return (
        <div id = 'semAvaliacaoAtendimento'>
            <img id = 'semDadosGrafico' src = {dadosImg} alt = ''/>
            <p>{props.texto} <br/> {props.subtexto}</p>
        </div>
    )
}

export default NenhumDadoGrafico

